import React from "react";

export enum VIEW_TYPE {
  GRID = "GRID",
  LIST = "LIST",
}

export enum SORTING_TYPE {
  ASC = "ASC",
  DESC = "DESC",
}

export enum OPTION_TYPE {
  CUSTOM = "CUSTOM",
  PREDEFINED = "PREDEFINED",
}

export interface FilterProps {
  view?: VIEW_TYPE;
  option?: OPTION_TYPE;
  sort: SORTING_TYPE;
  setView?: React.Dispatch<React.SetStateAction<VIEW_TYPE>>;
  setOption?: (option: OPTION_TYPE) => void;
  setSort: (sort: SORTING_TYPE) => void;
}
